import {
  GET_NAVIGATION_MENU,
  GET_NAVIGATION_MENU_SUCCESS,
  GET_NAVIGATION_MENU_FAILURE,
  ROLE_BASED_NAVIGATION_MENU,
  ROLE_BASED_NAVIGATION_MENU_SUCCESS,
  ROLE_BASED_NAVIGATION_MENU_FAILURE,
  GET_MENU_NAVIGATION_LIST,
  GET_MENU_NAVIGATION_LIST_SUCCESS,
  GET_MENU_NAVIGATION_LIST_FAILURE,
  CREATE_SINGLE_MENU_NAVIGATION,
  CREATE_SINGLE_MENU_NAVIGATION_SUCCESS,
  CREATE_SINGLE_MENU_NAVIGATION_FAILURE,
  UPDATE_SINGLE_MENU_NAVIGATION,
  UPDATE_SINGLE_MENU_NAVIGATION_SUCCESS,
  UPDATE_SINGLE_MENU_NAVIGATION_FAILURE,
  DELETE_SINGLE_MENU_NAVIGATION,
  DELETE_SINGLE_MENU_NAVIGATION_SUCCESS,
  DELETE_SINGLE_MENU_NAVIGATION_FAILURE,
  GET_AVAILABLE_MENU_NAVIGATION_ITEMS,
  GET_AVAILABLE_MENU_NAVIGATION_ITEMS_SUCCESS,
  GET_AVAILABLE_MENU_NAVIGATION_ITEMS_FAILURE,
  GET_SINGLE_NAVIGATION_MENU,
  GET_SINGLE_NAVIGATION_MENU_SUCCESS,
  GET_SINGLE_NAVIGATION_MENU_FAILURE,
  GET_MENU_ITEM_LIST,
  GET_MENU_ITEM_LIST_SUCCESS,
  GET_MENU_ITEM_LIST_FAILURE,
  GET_SINGLE_MENU_ITEM_DATA,
  GET_SINGLE_MENU_ITEM_DATA_SUCCESS,
  GET_SINGLE_MENU_ITEM_DATA_FAILURE,
  CREATE_SINGLE_MENU_ITEM,
  CREATE_SINGLE_MENU_ITEM_SUCCESS,
  CREATE_SINGLE_MENU_ITEM_FAILURE,
  UPDATE_SINGLE_MENU_ITEM,
  UPDATE_SINGLE_MENU_ITEM_SUCCESS,
  UPDATE_SINGLE_MENU_ITEM_FAILURE,
  DELETE_SINGLE_MENU_ITEM,
  DELETE_SINGLE_MENU_ITEM_SUCCESS,
  DELETE_SINGLE_MENU_ITEM_FAILURE,
  CREATE_MASTER_MENU_NAV_ITEM,
  CREATE_MASTER_MENU_NAV_ITEM_SUCCESS,
  CREATE_MASTER_MENU_NAV_ITEM_FAILURE,
  // Global menus - Task 24886
  GET_MASTER_MENU_NAV_LIST,
  GET_MASTER_MENU_NAV_LIST_SUCCESS,
  GET_MASTER_MENU_NAV_LIST_FAILURE,
  GET_MASTER_MENU_NAV_DATA,
  GET_MASTER_MENU_NAV_DATA_SUCCESS,
  GET_MASTER_MENU_NAV_DATA_FAILURE,
  CREATE_MASTER_MENU_NAV,
  CREATE_MASTER_MENU_NAV_SUCCESS,
  CREATE_MASTER_MENU_NAV_FAILURE,
  UPDATE_MASTER_MENU_NAV,
  UPDATE_MASTER_MENU_NAV_SUCCESS,
  UPDATE_MASTER_MENU_NAV_FAILURE,
  DELETE_MASTER_MENU_NAV,
  DELETE_MASTER_MENU_NAV_SUCCESS,
  DELETE_MASTER_MENU_NAV_FAILURE,
  ROLLOUT_MASTER_MENU_NAV,
  ROLLOUT_MASTER_MENU_NAV_SUCCESS,
  ROLLOUT_MASTER_MENU_NAV_FAILURE,
} from "./actionType";

// Action for Navigation Menu
export const getNavigationMenu = (id) => ({
  type: GET_NAVIGATION_MENU,
  payload: id,
});

export const getNavigationMenuSuccess = (data) => ({
  type: GET_NAVIGATION_MENU_SUCCESS,
  payload: data,
});

export const getNavigationMenuFailure = (error) => ({
  type: GET_NAVIGATION_MENU_FAILURE,
  payload: error,
});

// Role Based Navigation Menu
export const roleBasedNavigationMenu = (id) => ({
  type: ROLE_BASED_NAVIGATION_MENU,
  payload: id,
});

export const roleBasedNavigationMenuSuccess = (data) => ({
  type: ROLE_BASED_NAVIGATION_MENU_SUCCESS,
  payload: data,
});

export const roleBasedNavigationMenuFailure = (error) => ({
  type: ROLE_BASED_NAVIGATION_MENU_FAILURE,
  payload: error,
});

// Get menu navigation list
export const getMenuNavigationList = () => ({
  type: GET_MENU_NAVIGATION_LIST,
});

export const getMenuNavigationListSuccess = (data) => ({
  type: GET_MENU_NAVIGATION_LIST_SUCCESS,
  payload: data,
});

export const getMenuNavigationListFailure = (error) => ({
  type: GET_MENU_NAVIGATION_LIST_FAILURE,
  payload: error,
});

// Create Single Menu Navigation
export const createSingleMenuNavigation = (data) => ({
  type: CREATE_SINGLE_MENU_NAVIGATION,
  payload: data,
});

export const createSingleMenuNavigationSuccess = (data) => ({
  type: CREATE_SINGLE_MENU_NAVIGATION_SUCCESS,
  payload: data,
});

export const createSingleMenuNavigationFailure = (error) => ({
  type: CREATE_SINGLE_MENU_NAVIGATION_FAILURE,
  payload: error,
});

// Update Single Menu Navigation
export const updateSingleMenuNavigation = (data) => ({
  type: UPDATE_SINGLE_MENU_NAVIGATION,
  payload: data,
});

export const updateSingleMenuNavigationSuccess = (data) => ({
  type: UPDATE_SINGLE_MENU_NAVIGATION_SUCCESS,
  payload: data,
});

export const updateSingleMenuNavigationFailure = (error) => ({
  type: UPDATE_SINGLE_MENU_NAVIGATION_FAILURE,
  payload: error,
});

// Delete Single Menu Navigation
export const deleteSingleMenuNavigation = (data) => ({
  type: DELETE_SINGLE_MENU_NAVIGATION,
  payload: data,
});

export const deleteSingleMenuNavigationSuccess = (data) => ({
  type: DELETE_SINGLE_MENU_NAVIGATION_SUCCESS,
  payload: data,
});

export const deleteSingleMenuNavigationFailure = (error) => ({
  type: DELETE_SINGLE_MENU_NAVIGATION_FAILURE,
  payload: error,
});

// Get Available Menu Navigation Items
export const getAvailableMenuNavigationItems = () => ({
  type: GET_AVAILABLE_MENU_NAVIGATION_ITEMS,
});

export const getAvailableMenuNavigationItemsSuccess = (data) => ({
  type: GET_AVAILABLE_MENU_NAVIGATION_ITEMS_SUCCESS,
  payload: data,
});

export const getAvailableMenuNavigationItemsFailure = (error) => ({
  type: GET_AVAILABLE_MENU_NAVIGATION_ITEMS_FAILURE,
  payload: error,
});

// Get Single Navigation Menu
export const getSingleNavigationMenu = (id) => ({
  type: GET_SINGLE_NAVIGATION_MENU,
  payload: id,
});

export const getSingleNavigationMenuSuccess = (data) => ({
  type: GET_SINGLE_NAVIGATION_MENU_SUCCESS,
  payload: data,
});

export const getSingleNavigationMenuFailure = (error) => ({
  type: GET_SINGLE_NAVIGATION_MENU_FAILURE,
  payload: error,
});

//GET_MENU_ITEM_LIST
export const getMenuItemList = () => ({
  type: GET_MENU_ITEM_LIST,
});

export const getMenuItemListSuccess = (data) => ({
  type: GET_MENU_ITEM_LIST_SUCCESS,
  payload: data,
});

export const getMenuItemListFailure = (error) => ({
  type: GET_MENU_ITEM_LIST_FAILURE,
  payload: error,
});

//GET_SINGLE_MENU_ITEM_DATA
export const getSingleMenuItemData = (id) => ({
  type: GET_SINGLE_MENU_ITEM_DATA,
  payload: id,
});

export const getSingleMenuItemDataSuccess = (data) => ({
  type: GET_SINGLE_MENU_ITEM_DATA_SUCCESS,
  payload: data,
});

export const getSingleMenuItemDataFailure = (error) => ({
  type: GET_SINGLE_MENU_ITEM_DATA_FAILURE,
  payload: error,
});

//CREATE_SINGLE_MENU_ITEM
export const createSingleMenuItem = (data) => ({
  type: CREATE_SINGLE_MENU_ITEM,
  payload: data,
});

export const createSingleMenuItemSuccess = (data) => ({
  type: CREATE_SINGLE_MENU_ITEM_SUCCESS,
  payload: data,
});

export const createSingleMenuItemFailure = (error) => ({
  type: CREATE_SINGLE_MENU_ITEM_FAILURE,
  payload: error,
});

//UPDATE_SINGLE_MENU_ITEM
export const updateSingleMenuItem = (data) => ({
  type: UPDATE_SINGLE_MENU_ITEM,
  payload: data,
});

export const updateSingleMenuItemSuccess = (data) => ({
  type: UPDATE_SINGLE_MENU_ITEM_SUCCESS,
  payload: data,
});

export const updateSingleMenuItemFailure = (error) => ({
  type: UPDATE_SINGLE_MENU_ITEM_FAILURE,
  payload: error,
});

//DELETE_SINGLE_MENU_ITEM
export const deleteSingleMenuItem = (data) => ({
  type: DELETE_SINGLE_MENU_ITEM,
  payload: data,
});

export const deleteSingleMenuItemSuccess = (data) => ({
  type: DELETE_SINGLE_MENU_ITEM_SUCCESS,
  payload: data,
});

export const deleteSingleMenuItemFailure = (error) => ({
  type: DELETE_SINGLE_MENU_ITEM_FAILURE,
  payload: error,
});

//CREATE_MASTER_MENU_NAV_ITEM
export const createMasterMenuNavItem = (data) => ({
  type: CREATE_MASTER_MENU_NAV_ITEM,
  payload: data,
});

export const createMasterMenuNavItemSuccess = (data) => ({
  type: CREATE_MASTER_MENU_NAV_ITEM_SUCCESS,
  payload: data,
});

export const createMasterMenuNavItemFailure = (error) => ({
  type: CREATE_MASTER_MENU_NAV_ITEM_FAILURE,
  payload: error,
});

// ---------------------------------------------------------------------------
// Global menus - Task 24886
// ---------------------------------------------------------------------------
export const getMasterMenuNavList = () => ({ type: GET_MASTER_MENU_NAV_LIST });
export const getMasterMenuNavListSuccess = (data) => ({
  type: GET_MASTER_MENU_NAV_LIST_SUCCESS,
  payload: data,
});
export const getMasterMenuNavListFailure = (error) => ({
  type: GET_MASTER_MENU_NAV_LIST_FAILURE,
  payload: error,
});

export const getMasterMenuNavData = (data) => ({
  type: GET_MASTER_MENU_NAV_DATA,
  payload: data,
});
export const getMasterMenuNavDataSuccess = (data) => ({
  type: GET_MASTER_MENU_NAV_DATA_SUCCESS,
  payload: data,
});
export const getMasterMenuNavDataFailure = (error) => ({
  type: GET_MASTER_MENU_NAV_DATA_FAILURE,
  payload: error,
});

export const createMasterMenuNav = (data) => ({
  type: CREATE_MASTER_MENU_NAV,
  payload: data,
});
export const createMasterMenuNavSuccess = (data) => ({
  type: CREATE_MASTER_MENU_NAV_SUCCESS,
  payload: data,
});
export const createMasterMenuNavFailure = (error) => ({
  type: CREATE_MASTER_MENU_NAV_FAILURE,
  payload: error,
});

export const updateMasterMenuNav = (data) => ({
  type: UPDATE_MASTER_MENU_NAV,
  payload: data,
});
export const updateMasterMenuNavSuccess = (data) => ({
  type: UPDATE_MASTER_MENU_NAV_SUCCESS,
  payload: data,
});
export const updateMasterMenuNavFailure = (error) => ({
  type: UPDATE_MASTER_MENU_NAV_FAILURE,
  payload: error,
});

export const deleteMasterMenuNav = (data) => ({
  type: DELETE_MASTER_MENU_NAV,
  payload: data,
});
export const deleteMasterMenuNavSuccess = (data) => ({
  type: DELETE_MASTER_MENU_NAV_SUCCESS,
  payload: data,
});
export const deleteMasterMenuNavFailure = (error) => ({
  type: DELETE_MASTER_MENU_NAV_FAILURE,
  payload: error,
});

export const rolloutMasterMenuNav = (data) => ({
  type: ROLLOUT_MASTER_MENU_NAV,
  payload: data,
});
export const rolloutMasterMenuNavSuccess = (data) => ({
  type: ROLLOUT_MASTER_MENU_NAV_SUCCESS,
  payload: data,
});
export const rolloutMasterMenuNavFailure = (error) => ({
  type: ROLLOUT_MASTER_MENU_NAV_FAILURE,
  payload: error,
});

